import { formatISO } from 'date-fns'

import { Campaign } from '../../model/campaign'
import { CopyCampaignParams, CreateCampaignParams, UpdateCampaignParams } from '../models'

const formatPeriodDateForPayload = (date?: Date) =>
  date ? formatISO(date, { representation: 'date' }) : undefined

const formatOwnersForPayload = (owners?: string[]) =>
  (owners ?? [])
    .map((owner) => owner.trim())
    .filter(Boolean)
    .join(',')

const buildCampaignBaseParams = (campaign: Partial<Campaign>) => ({
  'p.Title': campaign.title,
  'p.Status': campaign.status,
  'p.Countries': JSON.stringify(campaign.countries),
  'p.SubRoles': JSON.stringify(campaign.subRoles),
  'p.FillingType': campaign.fillingType,
  'p.PeriodStart': formatPeriodDateForPayload(campaign.period?.from),
  'p.PeriodEnd': formatPeriodDateForPayload(campaign.period?.to),
  'p.MsFormsUrl': campaign.msFormsUrl || '',
  'p.Owners': formatOwnersForPayload(campaign.owners),
})

export const buildCampaignCreateParams = (campaign: CreateCampaignParams) =>
  buildCampaignBaseParams(campaign)

export const buildCampaignCopyParams = ({ sourceCampaignId, ...campaign }: CopyCampaignParams) => ({
  'p.SourceCampaignId': sourceCampaignId,
  ...buildCampaignBaseParams(campaign),
})

export const buildCampaignUpdateParams = ({ campaign }: UpdateCampaignParams) => ({
  'p.EntryId': campaign.entryId,
  ...buildCampaignBaseParams(campaign),
})
